import {
    SET_RECAP,
    SET_STATUS_RECAP,
    SET_TEXTES_RECAP,
} from './mutations-type'

var _ = require('underscore');

// initial state
const state = {
    recap: null,
    textes: null,
    status_recap: [],
}

// mutations
const mutations = {
    [SET_RECAP](state, message) {
        state.recap = message;
    },
    [SET_STATUS_RECAP](state, message) {
        state.status_recap = message;
    },
    [SET_TEXTES_RECAP](state, message) {
        state.textes = message;
    },
}

const actions = {
    setRecap({commit}, msg) {
        commit(SET_RECAP, msg)
    },
    setStatusRecap({commit}, msg) {
        commit(SET_STATUS_RECAP, msg)
    },
    setTextesRecap({commit}, msg) {
        commit(SET_TEXTES_RECAP, msg)
    },
}

const getters = {
    getRecap: state => {
        return state.recap;
    },
    getStatusRecap: state => {
        return state.status_recap;
    },
    getTextesRecap: state => {
        return state.textes;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/store-recap.js